export const evaluationOptOutPageLanguages = ['es', 'en']

export const legalLinks = {
  es: {
    termsAndConditions: 'https://www.reveni.com/es/legal/terms-and-conditions-user',
    privacyPolicy: 'https://www.reveni.com/es/legal/privacy',
  },
  en: {
    termsAndConditions: 'https://www.reveni.com/legal/terms-and-conditions-user',
    privacyPolicy: 'https://www.reveni.com/legal/privacy',
  },
}
